import HouseMainFeaturesSelector from "./houses/components/HouseMainFeaturesSelector";

const projectWidgets: any = {
  "house-main-features-select": HouseMainFeaturesSelector,
};

export default projectWidgets;
